(() => {
    const storageKey = "rtpCompletedStages";

    const stages = [
        "compass",
        "consideration",
        "scope",
        "road-test",
        "discuss",
        "implement"
    ];

    const stageUrls = {
        compass: "/a-compass-for-reflection/",
        consideration: "/consideration/",
        scope: "/scope/",
        "road-test": "/road-test/",
        discuss: "/discuss/",
        implement: "/implement/"
    };

    function readCompletedStages() {
        try {
            const saved = JSON.parse(localStorage.getItem(storageKey) || "[]");

            return new Set(
                Array.isArray(saved)
                    ? saved.filter((stage) => stages.includes(stage))
                    : []
            );
        } catch {
            return new Set();
        }
    }

    function saveCompletedStages(completed) {
        localStorage.setItem(storageKey, JSON.stringify([...completed]));
    }

    function renderProgress() {
        const root = document.querySelector("[data-rtp-stage-progress]");

        if (!root) {
            return;
        }

        const completed = readCompletedStages();
        const count = stages.filter((stage) => completed.has(stage)).length;
        const percentage = Math.round((count / stages.length) * 100);

        const countElement = root.querySelector("[data-rtp-stage-count]");
        const percentElement = root.querySelector("[data-rtp-stage-percent]");
        const fillElement = root.querySelector("[data-rtp-stage-fill]");

        if (countElement) {
            countElement.textContent = String(count);
        }

        if (percentElement) {
            percentElement.textContent = `${percentage}% complete`;
        }

        if (fillElement) {
            fillElement.style.width = `${percentage}%`;
        }

        root.querySelectorAll("[data-rtp-stage]").forEach((element) => {
            element.classList.toggle(
                "is-complete",
                completed.has(element.dataset.rtpStage)
            );
        });

        document.querySelectorAll("[data-rtp-stage-card]").forEach((card) => {
            card.classList.toggle(
                "is-complete",
                completed.has(card.dataset.rtpStageCard)
            );
        });

        const continueButton = root.querySelector(".qolsta-button");
        const nextStage = stages.find((stage) => !completed.has(stage));

        if (continueButton && nextStage) {
            continueButton.href = stageUrls[nextStage];
        }

        if (continueButton && !nextStage) {
            continueButton.href = "/journey/";
            continueButton.textContent = "Journey complete ✓";
        }
    }

    document
        .querySelectorAll("[data-rtp-complete-stage]")
        .forEach((button) => {
            button.addEventListener("click", () => {
                const completed = readCompletedStages();
                completed.add(button.dataset.rtpCompleteStage);
                saveCompletedStages(completed);
            });
        });

    renderProgress();
    window.addEventListener("storage", renderProgress);
})();
